import React from "react";
import { createPortal } from "react-dom";
import { CURRENT_VIEW_SECTION_ID } from "../constants/sideNav";
import SideNavCurrentViewSection from "../sections/SideNavCurrentViewSection";
import Flex from "../../Flex";
import { useSideNavStateContext } from "../context/SideNavStateProvider";
import useResponsive from "../hooks/useResponsive";
import PropTypes from "prop-types";
import { CurrentViewSectionShape } from "../types/sideNav";

/**
 * Renders the "Currently Viewing" section into the SideNav via a portal.
 * Mount this in the page that owns the current context (e.g. team page); it
 * will portal content into the slot reserved by CurrentViewSectionPortalTarget.
 */
const RenderCurrentViewSection = ({ viewingState }) => {
  const container = document.getElementById(CURRENT_VIEW_SECTION_ID);
  const { isExpanded } = useSideNavStateContext();
  const { isSmallScreen } = useResponsive();

  // Don't render if there's no valid viewing state, no name, or no container
  if (!viewingState || !viewingState.name || !container) {
    return null;
  }

  return createPortal(
    <Flex flexDirection="column" gap="s">
      <SideNavCurrentViewSection
        {...viewingState}
        isExpanded={isExpanded}
        isSmallScreen={isSmallScreen}
      />
    </Flex>,
    container
  );
};

RenderCurrentViewSection.propTypes = {
  viewingState: PropTypes.shape(CurrentViewSectionShape)
};

export default RenderCurrentViewSection;
